<template>
  <div v-if="loading" class="loading-container">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>加载配置中...</p>
    </div>
  </div>
  <component v-else-if="configComponent" :is="configComponent" :id="configId" :viewMode="isViewMode" />
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getConfig } from '@/api/configs'
import CreateConfigYmirInternational from './CreateConfigYmirInternational.vue'
import CreateConfigYmirKorea from './CreateConfigYmirKorea.vue'

export default {
  name: 'ConfigEditorWrapper',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const loading = ref(true)
    const configComponent = ref(null)
    const isViewMode = computed(() => {
      return route.query.viewMode === 'true' || route.query.viewMode === true
    })

    onMounted(async () => {
      try {
        // 加载配置信息
        const response = await getConfig(props.id)
        const config = response.data

        if (!config) {
          ElMessage.error('配置不存在')
          router.push('/dashboard/scripts')
          return
        }

        // 根据配置的游戏类型选择正确的组件
        const game = config.game || '尤弥尔传奇韩服'
        if (game === '尤弥尔传奇国际服') {
          configComponent.value = CreateConfigYmirInternational
        } else {
          configComponent.value = CreateConfigYmirKorea
        }
      } catch (error) {
        console.error('加载配置失败:', error)
        ElMessage.error('加载配置失败: ' + (error.response?.data?.message || error.message))
        router.push('/dashboard/scripts')
      } finally {
        loading.value = false
      }
    })

    return {
      loading,
      configComponent,
      configId: props.id,
      isViewMode
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top: 3px solid #007aff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner p {
  margin: 0;
  color: #86868b;
  font-size: 16px;
}
</style>

